export const categoryFilter = `query GetOcplcCategories($filter: OcplcCategoryRequest!) {
    ocplcCategory(filter: $filter) {
      categories {
        value
        text
      }
    }
  }`